/**
 * useTrackEvent Hook
 *
 * Provides a `trackEvent` function for manual/imperative event tracking.
 * Use this for complex scenarios where auto-tracking (Redux middleware,
 * click tracking, page tracking) is not sufficient.
 *
 * @example
 * ```tsx
 * const { trackEvent } = useTrackEvent();
 * trackEvent('conversation.banner.viewed', { banner_type: 'credit_limit' });
 * ```
 *
 * @module @ideoz/core/analytics/hooks/useTrackEvent
 */

import { useCallback } from 'react';
import { trackEvent as serviceTrackEvent } from '../analytics.service';

/**
 * Hook that returns a stable trackEvent function for manual event tracking.
 */
export function useTrackEvent() {
  const trackEvent = useCallback(
    (eventName: string, properties?: Record<string, unknown>) => {
      serviceTrackEvent(eventName, properties);
    },
    [],
  );

  return { trackEvent };
}
